RivalIQ.apps.Site.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.EmailNeedsVerification = Marionette.View.extend({

        ui: {
            mainView: '.x-main-view',
            emailSentView: '.x-email-sent-view',
            editEmailView: '.x-edit-email-view',

            userEmail: '.x-user-email',
            userEmailSent: '.x-user-email-sent',
            validationMessage: '.x-validation-msg',
            resendEmailBtn: '.x-resend-email-btn',
            resetSendEmailBtn: '.x-resend-new-email-btn'
        },

        events: {
            'click @ui.resendEmailBtn': 'onEmailResend',
            'click @ui.resetSendEmailBtn': 'onSendToNewEmail',
            'click .x-edit-email': 'onEmailEdit',
            'click .x-contact-support': 'showIntercom',
            'keypress #email_input': 'onKeypressed'
        },

        onEmailResend: function () {
            const me = this;

            const emailAddress = me.ui.userEmail[0].textContent;
            const csrfToken = $('#_csrf').val();

            me.ui.resendEmailBtn.toggleClass('disabled', true);

            me.ui.validationMessage.hide();

            $.ajax({
                type: 'POST',
                url: '/api/users/resendVerificationEmail',
                data: {
                    email: emailAddress,
                    _csrf: csrfToken
                },
                error: function () {
                    me.ui.resetSendEmailBtn.toggleClass('disabled', false);
                    me.showErrorMessage();
                },
                success: function () {
                    me.ui.mainView.hide();
                    me.ui.emailSentView.show();

                    me.ui.userEmailSent.html(emailAddress);

                    RivalIQ.execute('tracking:push', RivalIQ.tracking.metric.ResentEmailVerification);
                }
            });
        },

        onEmailEdit: function () {
            const me = this;

            me.ui.mainView.hide();
            me.ui.editEmailView.show();
        },

        onSendToNewEmail: function () {
            const me = this;

            me.ui.validationMessage.hide();

            let newEmailAddress = $('#email_input').val();
            newEmailAddress = newEmailAddress.toLowerCase();

            if (!newEmailAddress) {
                me.showErrorMessage('Email is required');
            } else {
                me.ui.resetSendEmailBtn.toggleClass('disabled', true);

                $.ajax({
                    type: 'POST',
                    url: '/api/users/updateVerificationEmail',
                    data: {
                        newEmailAddress: newEmailAddress
                    },
                    error: function (model) {
                        let errorText = null;
                        me.ui.resetSendEmailBtn.toggleClass('disabled', false);

                        if (_.get(model, ['errorObj', 'name']) === 'EmailAlreadyExistsError') {
                            errorText = RivalIQ.strings.email_verification_required_email_exists_error;
                        }

                        me.showErrorMessage(errorText);
                    },
                    success: function () {
                        me.ui.editEmailView.hide();
                        me.ui.emailSentView.show();

                        me.ui.userEmailSent.html(newEmailAddress);

                        RivalIQ.execute('tracking:push', RivalIQ.tracking.metric.ResentEmailVerificationToNewEmail);
                    }
                });
            }
        },

        showErrorMessage: function (text) {
            const me = this;
            me.ui.validationMessage.show().html(text || RivalIQ.strings.email_verification_required_default_error);
        },

        showIntercom: function (e) {
            if (window.Intercom) {
                e.preventDefault();
                window.Intercom('show');
            }
        },

        onKeypressed: function (e) {
            const me = this;

            if (e.which === 13) {
                me.onSendToNewEmail();
            }
        },

        initialize: function () {
            const me = this;
            me.bindUIElements();
        }
    });

});
